import React from "react";
import Logo from "src/images/logo.svg";
import MailTo from "src/images/mailto_icon.svg";
import Instagram from "src/images/instagram_icon.svg";
import LinkedIn from "src/images/linkedin_icon.svg";
import Heading from "utils/Heading";

const Footer = ({ settings }) => {
  return (
    <footer className="mx-auto px-6 py-8 lg:px-16">
      <div className="mb-6 block items-center md:flex">
        <div className="mr-auto mb-6 md:mb-0">
          <div className="text-primary mb-3">
            <Logo />
          </div>
        </div>
        <div className="ml-auto">
          <div className="flex items-center gap-x-6">
            <a href="mailto:hello@stanleyandco.com" className="text-primary">
              <MailTo width="150" />
            </a>
            <a
              href="https://www.instagram.com/stanleyandcostudio/"
              className="text-primary"
              target="_blank"
            >
              <Instagram width="25" />
            </a>
            <a
              href="https://www.linkedin.com/company/stanleyandcostudio"
              className="text-primary"
              target="_blank"
            >
              <LinkedIn width="25" />
            </a>
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="mr-auto">
          <div className="text-primary max-w-2xl text-sm">
            © Stanley & Co. Studio Ltd. <br />
            Registered Company Number 13914459. VAT number 407 7708 83. &{" "}
            <a
              className="hover:underline"
              href="https://www.stanleyandco.com/small-print/"
            >
              some small print
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
